import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSizeM = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 33.195 33.195",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "M_Banner",
		transform: "translate(6541 21323)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group_181",
			"data-name": "Group 181",
			transform: "translate(-6541 -21323)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_208",
				"data-name": "Path 208",
				d: "M32.507,4.844a1.742,1.742,0,0,1,1.844,1.844V32.507a1.742,1.742,0,0,1-1.844,1.844H6.688a1.742,1.742,0,0,1-1.844-1.844V6.688A1.742,1.742,0,0,1,6.688,4.844H32.507m0-1.844H6.688A3.7,3.7,0,0,0,3,6.688V32.507a3.7,3.7,0,0,0,3.688,3.688H32.507a3.7,3.7,0,0,0,3.688-3.688V6.688A3.7,3.7,0,0,0,32.507,3Z",
				transform: "translate(-3 -3)"
			})
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_2712",
			"data-name": "Path 2712",
			d: "M4.581-7.82l3.7,10.46L11.97-7.82h3.9V6.6H12.891V2.659l.3-6.8L9.3,6.6H7.255L3.373-4.136l.3,6.795V6.6H.7V-7.82Z",
			transform: "translate(-6532.663 -21305.732)"
		})]
	})
});
export default SvgSizeM;
